/*
 * Phase 85.2 — Session lifecycle status badge.
 * Compact chip with colour + icon + tooltip per session_state so staff
 * can see at a glance where a training session is in its attendance
 * workflow without relying on colour alone (accessibility).
 */
import { CalendarClock, ClipboardList, LoaderCircle, CheckCircle2 } from 'lucide-react';

const CONFIG = {
  scheduled: {
    label: 'Scheduled',
    bg: 'bg-gray-100 text-gray-700 border-gray-200',
    Icon: CalendarClock,
    tooltip: 'Session created — roster still follows current Tags/Squads.',
  },
  roster_prepared: {
    label: 'Roster Prepared',
    bg: 'bg-sky-50 text-sky-800 border-sky-200',
    Icon: ClipboardList,
    tooltip: 'Participant snapshot is frozen. Future Tag/Squad changes will NOT affect this session.',
  },
  in_progress: {
    label: 'Attendance In Progress',
    bg: 'bg-amber-50 text-amber-800 border-amber-200',
    Icon: LoaderCircle,
    tooltip: 'Staff have started marking attendance for this session.',
  },
  completed: {
    label: 'Attendance Completed',
    bg: 'bg-emerald-50 text-emerald-800 border-emerald-200',
    Icon: CheckCircle2,
    tooltip: 'Attendance finalised. Historical record is frozen.',
  },
};

export const SessionStatusBadge = ({ state, size = 'sm' }) => {
  const cfg = CONFIG[state] || CONFIG.scheduled;
  const Icon = cfg.Icon;
  const sizeCls = size === 'xs'
    ? 'text-[10px] px-1.5 py-0.5'
    : 'text-[11px] px-2 py-0.5';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border ${cfg.bg} ${sizeCls} font-medium`}
      title={cfg.tooltip}
      data-testid={`session-status-${state}`}
    >
      <Icon size={size === 'xs' ? 10 : 12} className={state === 'in_progress' ? 'animate-spin-slow' : ''} />
      {cfg.label}
    </span>
  );
};
